/**
 * Patch de sécurité pour Lucide React 
 * Ce module crée des composants d'icône sécurisés pour éviter les erreurs de constructeur
 */

import React from 'react';

// Fonction pour créer une icône sécurisée qui évite les problèmes de constructeur
const createSafeIcon = (label, svgPath) => {
  const SafeIcon = (props) => {
    // Récupérer les props standard
    const { color = 'currentColor', size = 24, className = '', ...otherProps } = props;
    
    // Retourner un SVG standard sans aucune logique de constructeur
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={`lucide lucide-${label.toLowerCase()} ${className}`}
        {...otherProps}
      >
        {svgPath}
      </svg>
    );
  };
  
  // Définir le nom affiché pour les DevTools
  SafeIcon.displayName = label;
  
  return SafeIcon;
};

// Création des icônes problématiques
export const Lock = createSafeIcon('Lock', (
  <>
    <rect width="18" height="11" x="3" y="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </>
));

// Autres icônes qui pourraient être nécessaires
export const ShieldLock = createSafeIcon('ShieldLock', (
  <>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10" />
    <path d="M8 11h8" />
    <path d="M12 8v6" />
  </>
));

// Export par défaut
export default { 
  Lock,
  ShieldLock
};